import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const useBooleanToString = () => {
  const { t } = useTranslation("core");
  return useCallback((value: boolean) => (value ? t("yes") : t("no")), [t]);
};
